import React from 'react';

/**
 * Holder for a section's light (glows, grid, claws). It fills the section
 * but fades out toward the top and bottom, so light never ends in a hard
 * horizontal edge: sections melt into one continuous arena.
 */
export default function SectionLight({ children, fadeTop = true, fadeBottom = true, bleed = '0px', className = '' }) {
  const mask = `linear-gradient(to bottom, ${fadeTop ? 'transparent 0%, #000 18%' : '#000 0%'}, ${
    fadeBottom ? '#000 82%, transparent 100%' : '#000 100%'
  })`;
  return (
    <div
      aria-hidden="true"
      className={`pnp-section-light ${className}`.trim()}
      style={{ top: `calc(0px - ${bleed})`, bottom: `calc(0px - ${bleed})`, WebkitMaskImage: mask, maskImage: mask }}
    >
      {children}
    </div>
  );
}
